import { UnitAllData } from '../../../units/models/unit-all-data';
import {mergePositionsWithUnits, selectUnit, selectUnits, setUnitsStats, UnitAllDataActionsUnion, updateUnits, zoomUnit} from '../actions/unit-all-data.actions';
import { UnitStats } from '../../../units/models/unit-stats';
import * as UnitSharedActions from '../actions/units-shared.actions';
import { UnitsApiActionsUnion, updateUnitNameSuccess } from '../actions/units-api.actions';

export interface State {
  unitAllData: UnitAllData[] | null;
  selectedUnitData: UnitAllData[] | null;
  unitData: UnitAllData | null;
  zoomUnit: UnitAllData | null;
  unitStats: UnitStats | null;
}

export const initialState: State = {
  unitAllData: [],
  selectedUnitData: [],
  unitData: null,
  zoomUnit: null,
  unitStats: {
    moving: null,
    business: null,
    parked: null,
    private: null,
    gpsOn: null,
    gpsOff: null,
    gsmOn: null,
    gsmOff: null,
  }
};

export function reducer(
  state = initialState,
  action: UnitAllDataActionsUnion | UnitSharedActions.UnitsSharedActionsUnion | UnitsApiActionsUnion
): State {
  switch (action.type) {
    case mergePositionsWithUnits.type: {
      return {
        ...state,
        unitAllData: action.unitAllData
      };
    }
    case selectUnit.type: {
      return {
        ...state,
        unitData: action.unitData
      };
    }
    case zoomUnit.type: {
      return {
        ...state,
        zoomUnit: action.unitData
      };
    }
    case updateUnits.type: {
      
      return {
        ...state,
        unitAllData: action.unitAllData
      };
    }
    case setUnitsStats.type: {
      return {
        ...state,
        unitStats: action.unitStats
      };
    }
    case selectUnits.type: {
      return {
        ...state,
        selectedUnitData: action.unitData
      };
    }
    case UnitSharedActions.clearData.type: {
      return {
        ...initialState
      };
    }
    case updateUnitNameSuccess.type: {
      const unitAllData = state.unitAllData.find(u => u.unit.unitId === action.data.unitId);
      if (unitAllData) {unitAllData.unit.unitName = action.data.unitName; }

      if (state?.unitData?.unit?.unitId === action?.data?.unitId) {
        state.unitData.unit.unitName = action.data.unitName;
      }
      return {
        ...state
      };
    }
    default: {
      return state;
    }
  }
}
export const getUnitAllData = (state: State) => state.unitAllData;
export const getSelectedUnitData = (state: State) => state.selectedUnitData;
export const getUnitData = (state: State) => state.unitData;
export const getZoomUnit = (state: State) => state.zoomUnit;
export const getUnitStats = (state: State) => state.unitStats;
